function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_42916_4757)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 2.75C21.7655 2.75 27.25 8.23451 27.25 15C27.25 21.7655 21.7655 27.25 15 27.25C8.23451 27.25 2.75 21.7655 2.75 15C2.75 8.23451 8.23451 2.75 15 2.75Z",
  fill: "white",
  stroke: "url(#paint0_linear_42916_4757)",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6476 11.0023L13.5198 11.3483C12.6858 13.6052 10.909 15.3846 8.65541 16.2196L8.30978 16.3478L8.65541 16.4757C10.909 17.3109 12.6858 19.0903 13.5198 21.3471L13.6476 21.6932L13.7755 21.3471C14.6094 19.0903 16.3862 17.3109 18.6399 16.4757L18.9854 16.3478L18.6399 16.2196C16.3862 15.3846 14.6094 13.6052 13.7755 11.3483L13.6476 11.0023ZM18.9854 8.60449L18.928 8.75967C18.5539 9.77215 17.7569 10.5703 16.746 10.9449L16.5911 11.0023L16.746 11.0598C17.7569 11.4344 18.5539 12.2325 18.928 13.2449L18.9854 13.4L19.0427 13.2449C19.4168 12.2325 20.2138 11.4344 21.2248 11.0598L21.3798 11.0023L21.2248 10.9449C20.2138 10.5703 19.4168 9.77215 19.0427 8.75967L18.9854 8.60449Z",
  fill: "#317AD0"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_42916_4757",
  x1: 37.0982,
  y1: 14.5128,
  x2: 3.75,
  y2: 14.5128,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#317AD0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A9D1FF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_42916_4757"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white"
})));
function SvgAiAssistantSparkleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantSparkleIcon);
export default __webpack_public_path__ + "static/media/ai-assistant-sparkle-icon.d2dc015a.svg";
export { ForwardRef as ReactComponent };